module.exports = __webpack_public_path__ + "img/Desktop_Banner_welcome.501c6efa.png";